import React from 'react';
import { css } from '@emotion/react';
import {
  acceptJoinRequest,
} from '../../web3/SFM-TeamsUtils';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-hot-toast';

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;
function JoiningRequestSingle({ teamId, player,callSaveSucceed }) {
  const [ isButtonClicked, setIsButtonClicked ] = React.useState();
  const acceptRequest = async () => {
    try {
      setIsButtonClicked(true);
      await acceptJoinRequest(teamId, player).then((e) => {
        console.log(e);

        toast.success(`${player} joined your team successfully`);
        setIsButtonClicked(false);
        callSaveSucceed();
      });
    } catch (e) {
      setIsButtonClicked(false);
      toast.error(e.message);
    }
  };

  return (
    <Row className="title-style-three text-center">
      <Col>
        <span className="text-dark">{player}</span>
      </Col>
      <Col>
        <button
          onClick={() => {
            acceptRequest();
          }}
          className={`btn btn-style-two flaot-right text-white`}
        >
          {isButtonClicked ? <div className="lds-dual-ring"></div> : 'Accept'}
        </button>
      </Col>
    </Row>
  );
}

export default JoiningRequestSingle;
